import * as React from 'react';
import { connect } from 'react-redux';
import { SET_CLAIM_DATA } from '../../../constants/constants';
import FnolStep9Sub1ConfirmCarDetails from './FnolStep9Sub1ConfirmCarDetails';

class FnolStep9 extends React.Component<any, any>  {
    constructor(props) {
        super(props)
    }
    public render() {

        if (this.props.claimSubmit.selectedClaimStep.subStep === 1) {
            return (<FnolStep9Sub1ConfirmCarDetails />);
        }
        else {
            return <>
            </>;
        }
    }
}

export const setTimeShow = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                IsIncidentDateClicked: !getState().claimSubmit.IsIncidentDateClicked,
            }
        });
    }
}

const mapStateToProps = (state: any) => {
    return {
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchSetTimeShow: () => dispatch(setTimeShow()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(FnolStep9)